module.exports = __webpack_public_path__ + "media/packs/site/assets/images/error_404-fad6bf34da0eea8c0139836349ecd610.png";